import React from 'react';

const PrivacyPolicyPage = () => {
  const summaryCardStyle = {
    border: '1px solid #e9ecef',
    borderRadius: '12px',
    padding: '18px',
    background: '#ffffff',
    marginBottom: '20px'
  };

  const infoAlertStyle = {
    border: '1px solid #d0ebff',
    borderRadius: '12px',
    padding: '14px 16px',
    background: '#f1f8ff',
    marginBottom: '24px'
  };

  const sectionStyle = {
    marginTop: '20px',
    marginBottom: '18px'
  };

  return (
    <>
      <div className="blog-area gray-300">
        <div className="container position-relative pt-110 pb-110">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <h3>Politique de confidentialité</h3>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="single-post">
                <div className="single-post-content">
                  <div style={summaryCardStyle}>
                    <p style={{ marginBottom: '8px' }}>
                      <strong>Responsable du traitement :</strong> Association SIRRAT
                    </p>
                    <p style={{ marginBottom: '8px' }}>
                      <strong>Site :</strong> masjidy.fr
                    </p>
                    <p style={{ marginBottom: '8px' }}>
                      <strong>N° SIRET :</strong> 100 463 603 00017
                    </p>
                    <p style={{ marginBottom: 0 }}>
                      <strong>Type de service :</strong> site informatif et services associés (application mobile, formulaire de contact)
                    </p>
                  </div>

                  <div style={infoAlertStyle}>
                    <strong>Information RGPD :</strong> Le point de contact RGPD est <strong>info@masjidy.fr</strong>.
                  </div>

                  <section style={sectionStyle}>
                    <h4>1. Objet de la politique</h4>
                    <p>
                      La présente politique de confidentialité explique quelles données personnelles sont traitées,
                      pourquoi elles le sont, sur quelles bases légales, pendant combien de temps, et quels sont vos droits.
                    </p>
                    <p>
                      Elle est publiée conformément au Règlement (UE) 2016/679 (RGPD) et à la loi Informatique et Libertés.
                    </p>
                  </section>

                  <section style={sectionStyle}>
                    <h4>2. Catégories de données traitées</h4>
                    <p><strong>Données fournies directement :</strong></p>
                    <ul>
                      <li>Nom et prénom</li>
                      <li>Adresse e-mail</li>
                      <li>Numéro de téléphone (facultatif)</li>
                      <li>Objet et contenu du message envoyé via le formulaire de contact</li>
                    </ul>

                    <p><strong>Données techniques collectées automatiquement :</strong></p>
                    <ul>
                      <li>Adresse IP, date/heure, informations navigateur/appareil</li>
                      <li>Pages consultées et interactions de navigation</li>
                      <li>Données de mesure d&apos;audience (si cookie analytique activé)</li>
                    </ul>
                  </section>

                  <section style={sectionStyle}>
                    <h4>3. Finalités et bases légales (article 6 RGPD)</h4>
                    <ul>
                      <li>
                        <strong>Répondre aux demandes de contact</strong> — Base légale : intérêt légitime (art. 6.1.f) ou mesures précontractuelles (art. 6.1.b)
                      </li>
                      <li>
                        <strong>Assurer la sécurité du service</strong> (journalisation, prévention d&apos;abus) — Base légale : intérêt légitime (art. 6.1.f)
                      </li>
                      <li>
                        <strong>Respecter les obligations légales</strong> (réquisitions, conservation probatoire) — Base légale : obligation légale (art. 6.1.c)
                      </li>
                      <li>
                        <strong>Mesure d&apos;audience non essentielle / cookies analytiques</strong> — Base légale : consentement (art. 6.1.a), lorsque requis
                      </li>
                    </ul>
                  </section>

                  <section style={sectionStyle}>
                    <h4>4. Destinataires des données</h4>
                    <p>Les données peuvent être accessibles, selon les besoins :</p>
                    <ul>
                      <li>Aux personnes habilitées au sein de l&apos;Association SIRRAT</li>
                      <li>Aux sous-traitants techniques (hébergement, outils de messagerie, mesure d&apos;audience)</li>
                      <li>Aux autorités compétentes lorsque la loi l&apos;impose</li>
                    </ul>
                    <p>
                      <strong>Hébergeur (sous-traitant) :</strong>
                      <br />
                      Google Cloud France SARL
                      <br />
                      8 rue de Londres, 75009 Paris
                      <br />
                      RCS : 881721583
                    </p>
                    <p>
                      Les données ne sont pas vendues. Chaque accès est limité au strict nécessaire (principe de minimisation).
                    </p>
                  </section>

                  <section style={sectionStyle}>
                    <h4>5. Durées de conservation</h4>
                    <p>
                      Nous conservons les données personnelles uniquement le temps nécessaire aux finalités poursuivies,
                      conformément aux prescriptions légales et réglementaires.
                    </p>
                    <p>
                      Voici les durées de conservation appliquées aux principales catégories de données traitées :
                    </p>

                    <div className="table-responsive" style={{ marginBottom: '16px' }}>
                      <table className="table table-bordered" style={{ backgroundColor: '#fff' }}>
                        <thead>
                          <tr>
                            <th>Type de données</th>
                            <th>Durée de conservation</th>
                            <th>Point de départ du délai</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Données de votre compte utilisateur (identité, email, préférences, favoris)</td>
                            <td>3 ans</td>
                            <td>À compter de votre dernière activité sur le Site ou l&apos;Application (connexion, clic sur un lien, contact avec le support).</td>
                          </tr>
                          <tr>
                            <td>Données de contact &amp; formulaires (demandes d&apos;information, support)</td>
                            <td>Le temps du traitement (archivage possible jusqu&apos;à 5 ans en cas de contentieux)</td>
                            <td>Jusqu&apos;à la clôture complète de votre demande.</td>
                          </tr>
                          <tr>
                            <td>Vos contributions publiques (commentaires, avis)</td>
                            <td>Illimité (sauf demande de suppression)</td>
                            <td>Tant que le contenu associé reste en ligne. En cas de suppression de compte, les contributions sont anonymisées.</td>
                          </tr>
                          <tr>
                            <td>Données techniques de connexion (logs, adresses IP)</td>
                            <td>1 an</td>
                            <td>À compter de chaque connexion, pour répondre aux obligations légales de sécurité (LCEN).</td>
                          </tr>
                          <tr>
                            <td>Cookies et traceurs (mesure d&apos;audience, session)</td>
                            <td>13 mois maximum</td>
                            <td>À compter du dépôt du cookie sur votre terminal. Le consentement est redemandé à l&apos;issue de ce délai.</td>
                          </tr>
                          <tr>
                            <td>Données de géolocalisation (position GPS temps réel)</td>
                            <td>Aucune conservation</td>
                            <td>Utilisées instantanément pour fournir le service localisé, puis immédiatement supprimées.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <p><strong>Que se passe-t-il à l&apos;issue de ces délais ?</strong></p>
                    <p>Vos données sont soit :</p>
                    <ul>
                      <li>Supprimées définitivement de nos bases actives.</li>
                      <li>Anonymisées de manière irréversible (pour des besoins statistiques globaux).</li>
                      <li>Archivées en accès restreint (si la loi l&apos;impose), avant destruction finale.</li>
                    </ul>

                    <p>
                      Vous recevrez une notification par email 1 mois avant la suppression automatique de votre compte
                      pour inactivité, vous invitant à vous reconnecter si vous souhaitez le conserver.
                    </p>
                  </section>

                  <section style={sectionStyle}>
                    <h4>6. Transferts hors Union européenne</h4>
                    <p>
                      L&apos;hébergement principal des données est réalisé dans l&apos;Union européenne.
                    </p>
                    <p>
                      Si certains prestataires sont situés hors UE/EEE, les transferts sont encadrés par des garanties
                      appropriées (ex. clauses contractuelles types de la Commission européenne), lorsque requises.
                    </p>
                  </section>

                  <section style={sectionStyle}>
                    <h4>7. Sécurité des données</h4>
                    <ul>
                      <li>Chiffrement des échanges en HTTPS/TLS</li>
                      <li>Contrôle d&apos;accès aux environnements et données</li>
                      <li>Mesures de journalisation, sauvegarde et surveillance</li>
                    </ul>
                    <p>
                      Malgré ces mesures, aucun système n&apos;offre une sécurité absolue. En cas de violation de données,
                      les obligations de notification légales seront appliquées.
                    </p>
                  </section>

                  <section style={sectionStyle}>
                    <h4>8. Données des mineurs</h4>
                    <p>
                      Le service n&apos;est pas destiné à collecter intentionnellement des données de mineurs sans base
                      légale appropriée. En cas de collecte non intentionnelle, une suppression peut être demandée.
                    </p>
                  </section>

                  <section style={sectionStyle}>
                    <h4>9. Vos droits RGPD</h4>
                    <p>Vous disposez des droits suivants :</p>
                    <ul>
                      <li>Droit d&apos;accès</li>
                      <li>Droit de rectification</li>
                      <li>Droit à l&apos;effacement</li>
                      <li>Droit à la limitation du traitement</li>
                      <li>Droit à la portabilité</li>
                      <li>Droit d&apos;opposition</li>
                      <li>Droit de retirer votre consentement à tout moment (pour les traitements fondés sur le consentement)</li>
                    </ul>
                    <p>
                      Vous avez également le droit d&apos;introduire une réclamation auprès de la CNIL : https://www.cnil.fr
                    </p>
                  </section>

                  <section style={sectionStyle}>
                    <h4>10. Exercer vos droits</h4>
                    <p>
                      Pour toute demande (accès, rectification, suppression, opposition), contactez notre point de
                      contact RGPD à l&apos;adresse :
                      <br />
                      <strong>info@masjidy.fr</strong>
                    </p>
                    <p>
                      Merci d&apos;indiquer l&apos;objet « Données personnelles » et de préciser votre demande.
                      Une réponse est apportée dans un délai d&apos;un mois (prolongeable selon la complexité).
                    </p>
                  </section>

                  <section style={sectionStyle}>
                    <h4>11. Cookies</h4>
                    <p>
                      Nous utilisons des cookies strictement nécessaires au fonctionnement du site et, selon votre
                      choix, des cookies analytiques. Vous pouvez gérer vos préférences via le bandeau cookies.
                    </p>
                    <ul>
                      <li>
                        <strong>Cookies nécessaires</strong> : indispensables au fonctionnement du service.
                      </li>
                      <li>
                        <strong>Cookies analytiques</strong> : mesure d&apos;audience et amélioration de l&apos;expérience.
                      </li>
                    </ul>
                  </section>

                  <section style={sectionStyle}>
                    <h4>12. Modifications de la politique</h4>
                    <p>
                      Cette politique peut être mise à jour à tout moment pour tenir compte des évolutions légales,
                      techniques et organisationnelles. La date de mise à jour est indiquée ci-dessous.
                    </p>
                  </section>

                  <section style={sectionStyle}>
                    <h4>13. Contact</h4>
                    <p>
                      Association SIRRAT
                      <br />
                      30 rue du Vieil Abreuvoir, 78100 Saint-Germain-en-Laye
                      <br />
                      E-mail : info@masjidy.fr
                    </p>
                  </section>

                  <p className="mt-4">
                    Date d&apos;entrée en vigueur : 14 février 2026.
                    <br />
                    Dernière mise à jour : 14 février 2026.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyPage;
